/**
 * @deprecated Use <div className="grid"> instead
 */
import styled from 'styled-components'
import { Box } from './Box'

export const Grid = styled(Box)`
  display: grid;
`

Grid.defaultProps = {
  as: 'section',
}
